import { Injectable } from "@angular/core";
import { WindowRef } from "@obg/ngx.global.evo";

@Injectable({ providedIn: "root" })
export class GeolocationProvider {
	constructor(private windowRef: WindowRef) {}

	isSupported(): boolean {
		return !!this.windowRef.native?.navigator?.geolocation;
	}

	get(): Geolocation {
		return this.windowRef.native.navigator.geolocation;
	}
}
